import { Node, mergeAttributes } from '@tiptap/core';
import { DATA_STYLE_SET, DATA_TABLE_STYLE } from '../../../../grid/reduxStore/tableDefaultStyleValues.ts';

export interface CustomParagraphOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customParagraph: {
      setParagraph: () => ReturnType;
      setCustomParagraph: (attributes?: { rowType?: string }) => ReturnType;
    };
  }
}

export const CustomParagraph = Node.create<CustomParagraphOptions>({
  name: 'paragraph',
  priority: 1000,
  group: 'block',
  content: 'inline*',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      [DATA_TABLE_STYLE]: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute(DATA_TABLE_STYLE) || null,
        renderHTML: (attributes) => {
          if (!attributes[DATA_TABLE_STYLE]) return {};
          return { [DATA_TABLE_STYLE]: attributes[DATA_TABLE_STYLE] };
        },
      },
      [DATA_STYLE_SET]: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute(DATA_STYLE_SET) || null,
        renderHTML: (attributes) => {
          if (!attributes[DATA_STYLE_SET]) return {};
          return { [DATA_STYLE_SET]: attributes[DATA_STYLE_SET] };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: 'p' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands() {
    return {
      setParagraph: () => {
        return ({ commands }) => {
          return commands.setNode(this.name, {
            [DATA_TABLE_STYLE]: null,
            [DATA_STYLE_SET]: null,
          });
        };
      },
      setCustomParagraph: ({ rowType } = {}) => {
        return ({ commands }) => {
          const normalizedRowType = rowType?.toLowerCase() || null;
          return commands.setNode(this.name, {
            [DATA_TABLE_STYLE]: normalizedRowType,
            [DATA_STYLE_SET]: !!rowType,
          });
        };
      },
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Alt-0': () => this.editor.commands.setCustomParagraph(),
    };
  },
});
